import { clearConsent, getConsentState } from '../../utils/cookieConsent';

const ConsentDebugger = () => {
  const handleClearConsent = () => {
    clearConsent();
    window.location.reload();
  };

  const handleForceUpdate = () => {
    // Force update consent to denied
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied'
      });
      console.log('Forced consent to denied');
    }
  };

  const consentState = getConsentState();

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 bg-yellow-100 border border-yellow-300 rounded p-3 text-xs z-50">
      <div className="font-semibold mb-2">Consent Debug</div>
      <div className="mb-2">
        State: {consentState ? 
          `A:${consentState.analytics} M:${consentState.marketing}` : 
          'None'
        }
      </div>
      <button 
        onClick={handleClearConsent}
        className="bg-red-500 text-white px-2 py-1 rounded text-xs mr-2"
      >
        Reset Consent
      </button>
      <button 
        onClick={handleForceUpdate}
        className="bg-orange-500 text-white px-2 py-1 rounded text-xs"
      >
        Force Denied
      </button>
    </div>
  );
};

export default ConsentDebugger; 